import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import { Grid, Header, Segment, Table } from 'semantic-ui-react';
import AgGridTable from '../common/agGridTable'

import IndentPlanning from './indent';
import AvailablilityPlanning from './availablility';
import HeaderCTAPlanning from './headercta';

function PlanningReport(props) {
    let columnDefs = []

    const [totalIndent, setTotalIndent] = useState(0);
    const [overallTotalIndent, setOverallTotalIndent] = useState(0);
    const [pendingIndent, setPendingIndent] = useState(0);
    const [allottedIndent, setAllottedIndent] = useState(0);

    const [totalAvailability, setTotalAvailability] = useState(0);
    const [overallTotalAvailability, setOverallTotalAvailability] = useState(0);

    const [pendingAvailability, setPendingAvailability] = useState(0);
    const [allottedAvailability, setAllottedAvailability] = useState(0);

    const setTotalIndentP = (value) => {
        setTotalIndent(value)
    }
    const setTotalAvailabilityP = (value) => {
        setTotalAvailability(value)
    }

    return (



        <>
            <div id="dispatch_bar" className="planning-wrapper">
                {/* <div className="display-flex-center-justify-spacebtwn padding-lr-15"> */}
                <div className="display-flex-center-justify-spacebtwn padding-lr-15">
                    <h2 className="page-title">Planning</h2>

                    <div className="display-none">
                        <HeaderCTAPlanning></HeaderCTAPlanning>
                    </div>
                </div>
                <hr />
                <div className="display-flex-center padding-lr-15">
                    <div className='indent-box'>
                        <div class="ui stackable two column grid">
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2 planning-box-blue">
                                    <div className="statistic-planning-stat-container">
                                        <span className='planning-text-white'>{overallTotalIndent}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Total indents</span>
                                    </div>

                                </div>
                            </div>
                            <div class="column">
                            <div className="display-flex-center-justify-center statistic-planning-data mr-2">
                                    <div className="statistic-planning-stat-container">
                                        <span className='black-text'>{pendingIndent}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Pending indents</span>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="ui stackable two column grid">
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2 planning-box-blue">
                                    <div className="statistic-planning-stat-container">
                                        <span className='planning-text-white'>{totalIndent}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Total indents
                                            In this week</span>
                                    </div>

                                </div>

                            </div>
                            <div class="column">

                            <div className="display-flex-center-justify-center statistic-planning-data mr-2">
                                    <div className="statistic-planning-stat-container">
                                        <span className='black-text'>{allottedIndent}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Allotted indents </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='vehicle-availability'>
                        <div class="ui stackable two column grid">
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2 planning-box-blue">
                                    <div className="statistic-planning-stat-container">
                                        <span className='planning-text-white'>{overallTotalAvailability}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Total vehicle availability</span>
                                    </div>

                                </div>
                            </div>
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2">
                                    <div className="statistic-planning-stat-container">
                                    <span className='black-text'>{pendingAvailability}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span className='black-text'>Pending vehicle count</span>
                                    </div>

                                </div>



                            </div>

                        </div>

                        <div class="ui stackable two column grid">
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2 planning-box-blue">
                                    <div className="statistic-planning-stat-container">
                                        <span className='planning-text-white'>{totalAvailability}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                        <span>Total vehicle availability
                                            In this Week</span>
                                    </div>

                                </div>
                            </div>
                            <div class="column">
                                <div className="display-flex-center-justify-center statistic-planning-data mr-2">
                                    <div className="statistic-planning-stat-container">
                                    <span className='black-text'>{allottedAvailability}</span>
                                    </div>
                                    <div className="display-grid-center statistic-planning-head-container">
                                    <span className='black-text'>Allotted vehicle count</span>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div className="planning-container padding-lr-15">
                    <div className="planning-container-context"><IndentPlanning passed={props} setTotalIndent={setTotalIndentP} setPendingIndent={setPendingIndent} setAllottedIndent={setAllottedIndent} setOverallTotalIndent={setOverallTotalIndent}></IndentPlanning></div>
                    <div className="planning-container-context"><AvailablilityPlanning passed={props} setTotalAvailability={setTotalAvailabilityP} setPendingAvailability={setPendingAvailability} setAllottedAvailability={setAllottedAvailability} setOverallTotalAvailability={setOverallTotalAvailability}></AvailablilityPlanning></div>
                </div>
            </div>
        </>


        // <>   
        // <div id="dispatch_bar" className="planning-wrapper">
        // {/* <div className="display-flex-center-justify-spacebtwn padding-lr-15"> */}
        // <div className="display-flex-center-justify-spacebtwn padding-lr-15">
        //     <h2 className="page-title">Planning</h2>

        // <div className="display-none">
        //     <HeaderCTAPlanning></HeaderCTAPlanning>
        // </div>
        // </div>
        // <hr />
        // <div className="display-flex-center padding-lr-15">
        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center statistic-planning-head-container">
        //         <span>Total indents</span>
        //     </div>
        //     <div className="statistic-planning-stat-container">
        //         <span>{overallTotalIndent}</span>
        //     </div>
        // </div>

        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center statistic-planning-head-container">
        //         <span>Total indents
        //         In this week</span>
        //     </div>
        //     <div className="statistic-planning-stat-container">
        //         <span>{totalIndent}</span>
        //     </div>
        // </div>
        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center">
        //         <div><span>Pending indents &nbsp;:&nbsp;</span> <span>{pendingIndent}</span></div>
        //         <div><span>Allotted indents &nbsp;&nbsp;:&nbsp;&nbsp;</span><span>{allottedIndent}</span></div>
        //     </div>
        // </div>

        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center statistic-planning-head-container">
        //         <span>Total vehicle availability</span>
        //     </div>
        //     <div className="statistic-planning-stat-container">
        //         <span>{overallTotalAvailability}</span>
        //     </div>
        // </div>
        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center statistic-planning-head-container">
        //         <span>Total vehicle availability
        //         In this Week</span>
        //     </div>
        //     <div className="statistic-planning-stat-container">
        //         <span>{totalAvailability}</span>
        //     </div>
        // </div>
        // <div className="display-flex-center-justify-center statistic-planning-data mr-2">
        //     <div className="display-grid-center statistic-planning-head-container">
        //         <div><span>Pending vehicle count &nbsp;:&nbsp;</span> <span>{pendingAvailability}</span></div>
        //         <div><span>Allotted vehicle count &nbsp;&nbsp;:&nbsp;</span> <span>{allottedAvailability}</span></div>
        //     </div>
        // </div>
        // </div>
        // <div className="planning-container padding-lr-15">
        // <div className="planning-container-context"><IndentPlanning passed={props} setTotalIndent={setTotalIndentP} setPendingIndent={setPendingIndent} setAllottedIndent={setAllottedIndent} setOverallTotalIndent={setOverallTotalIndent}></IndentPlanning></div>
        // <div className="planning-container-context"><AvailablilityPlanning passed={props} setTotalAvailability={setTotalAvailabilityP} setPendingAvailability={setPendingAvailability} setAllottedAvailability={setAllottedAvailability} setOverallTotalAvailability={setOverallTotalAvailability}></AvailablilityPlanning></div>
        // </div>
        // </div>
        // </>



    )
}

export default PlanningReport
